<template>
  <el-dialog class="opus-status-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center>
    <div class="pv-content">
      <el-form label-width="220px">
        <el-form-item label="标题">
          {{ data.row.title }}
        </el-form-item>
        <el-form-item label="描述">
          {{ data.row.summary }}
        </el-form-item>
        <el-form-item label="创建时间" class="divider">
          {{ data.row.created_print }}
        </el-form-item>
        <el-form-item label="所属用户" class="divider">
          <el-tag
            size="mini"
            effect="dark"
            :type="data.row.user_type === 0 ? 'warning' : 'primary'"
            disable-transitions>{{ data.row.user_type_print }}
          </el-tag>
          {{ data.row.user_name }}
        </el-form-item>
        <el-form-item label="视频规格">
          <el-tag
            type="success"
            size="mini"
            effect="dark"
            v-if="data.row.spec<=180"
            disable-transitions>短视频
          </el-tag>
          <el-tag
            size="mini"
            effect="dark"
            v-else
            disable-transitions>长视频
          </el-tag>
          {{ tool.formatSeconds(data.row.duration) }}
        </el-form-item>
        <el-form-item label="原始大小" class="divider">
          {{ tool.formatB2MByte(data.row.file_size) }}M
        </el-form-item>
        <el-form-item label="图像评分" class="divider">
          {{ data.row.image_score }}
        </el-form-item>
        <el-form-item label="扫描次数">
          {{ data.row.scan_count }}
        </el-form-item>
        <el-form-item label="播放次数">
          {{ data.row.reviews_count }}
        </el-form-item>
        <el-form-item label="点赞次数">
          {{ data.row.like_count }}
        </el-form-item>
        <el-form-item label="分享次数">
          {{ data.row.share_count }}
        </el-form-item>
        <el-form-item label="评论次数">
          {{ data.row.comment_count }}
        </el-form-item>
        <el-form-item label="备注(仅后台可见)">
          {{ data.row.note }}
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      row: null
    }
  },
  methods: {}
}
</script>

<style>
.opus-status-dialog .el-dialog {
  background: #e5e9f2;
}

.opus-status-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.opus-status-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.opus-status-dialog .el-dialog__body {
  padding: 0;
}

.opus-status-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.opus-status-dialog .pv-content .el-form-item {
  margin-bottom: 0px;
}
.opus-status-dialog .pv-content .el-form-item.divider{
  border-bottom: 1px solid #348fe2;
}

.opus-status-dialog .pv-content .el-form-item__label {
  color: #0C0C0C;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/OpusStatusDialog.vue